import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** FETCH MEMBER DETAILS REPORT START *********************** */
export const postAllMemberDetailReport = (fetchData: any) => {
	const data = {
		PostAllMemberDetailReportToken: fetchData,
	};
	const url = `${API_URL}postAllMemberDetailReport`;
	return makeApiCall(url, data);
};
/** ***************** FETCH MEMBER DETAILS REPORT END *********************** */
